import styles from './ArticleBody.module.css';

interface ArticleBodyProps {
  children: React.ReactNode;
  className?: string;
}

export function ArticleBody({ children, className = '' }: ArticleBodyProps) {
  return (
    <div className={[styles.body, className].filter(Boolean).join(' ')}>
      {children}
    </div>
  );
}
